import React, { useEffect } from "react";

// Theme and Filesystem hooks
import { useThemeSwitch } from "sj-ui-toolkit/src/theme";
import { useFilesystem } from "../../../contexts/SandboxHooks";

// Lazy load local wrapper for Monaco Editor
const MonacoLocal = React.lazy(() => import("./MonacoLocal"));

import S from "./_styles.module.scss";

const Editor = () => {
  // Access the filesystem context and get the first file to display
  const {
    currentLanguage,
    fileLookup,
    beginEditingFile,
    editor: { currentPath: currentEditorPath, currentContents: currentEditorContents },
    handleEditorChange,
  } = useFilesystem();
  const firstFilePath = fileLookup ? Object.keys(fileLookup)[0] : null;

  // Get the current theme and figure out which Monaco theme to use
  const { appliedTheme } = useThemeSwitch();
  const monacoTheme = appliedTheme === "atlas-dark" ? "vs-dark" : "vs";

  useEffect(() => {
    if (firstFilePath && !currentEditorPath) {
      beginEditingFile(firstFilePath);
    }
  }, [firstFilePath, currentEditorPath, beginEditingFile]);

  return (
    <div className={S.container}>
      {currentEditorContents !== null && (
        <React.Suspense fallback={<p>Loading editor...</p>}>
          <MonacoLocal
            height="100%"
            language={currentLanguage}
            value={currentEditorContents}
            onChange={handleEditorChange}
            theme={monacoTheme}
            className={S.editor}
          />
        </React.Suspense>
      )}
    </div>
  );
};

export default Editor;
